import * as z from "zod";
var isAllDigits = function (value) {
    if (value.length === 0)
        return false;
    for (var i = 0; i < value.length; i += 1) {
        var code = value.charCodeAt(i);
        if (code < 48 || code > 57)
            return false;
    }
    return true;
};
export var isValidAddress = function (address) {
    for (var index = 0; index < address.length; index += 1) {
        var code = address.charCodeAt(index);
        // Reject non-ASCII
        if (code > 0x7f) {
            return false;
        }
        // Reject control characters
        if (code < 0x20 || code === 0x7f) {
            return false;
        }
        // 0–9
        if (code >= 48 && code <= 57) {
            continue;
        }
        // A–Z
        if (code >= 65 && code <= 90) {
            continue;
        }
        // a–z
        if (code >= 97 && code <= 122) {
            continue;
        }
        // Space
        if (code === 32) {
            continue;
        }
        // Allowed punctuation (comma intentionally excluded)
        switch (code) {
            case 35: // #
            case 39: // '
            case 45: // -
            case 46: // .
            case 47: // /
            case 92: // \
            case 40: // (
            case 41: // )
                continue;
        }
        // Anything else is illegal
        return false;
    }
    return true;
};
export var billingZipCodeSchema = z
    .string()
    .refine(isAllDigits, "Zip code must only contain numbers.")
    .length(5, "Zip code must be exactly 5 digits.");
export var avsCollectionSchema = z.object({
    address: z
        .string()
        .refine(isValidAddress, "The address includes an unsupported character. Commas and special symbols are not allowed.")
        .min(2, "Address is required."),
    zipCode: billingZipCodeSchema,
});
export var billingZipOnlySchema = z.object({
    address: z.string(),
    zipCode: billingZipCodeSchema,
});
